'use client';
import Carousel from '@ui/Carousel';
import { useAuth } from 'context/AuthContext';
import HomeSection from 'features/homepage/components/Home/components/HomeSection';
import { renderProductCards } from 'features/homepage/utils';
import { ProductLight } from 'models/product';

export const TrendingProductsSection = ({
  title,
  href,
  trendingProducts,
  section,
}: {
  trendingProducts: ProductLight[];
  title: string;
  href: string;
  section: string;
}) => {
  const { userDoc } = useAuth();
  if (userDoc || !trendingProducts?.length) return null;
  return (
    <HomeSection title={title} linkText="See All" href={href} carouselWrapper>
      <Carousel
        spacing={0}
        basis="basis-[48%] sm:basis-auto"
        className="-mt-12"
        items={renderProductCards(
          trendingProducts,
          {},
          {
            data_source: 'firebase',
            page: 'home',
            section,
          }
        )}
      />
    </HomeSection>
  );
};
